import { Field, FieldRow } from '@/components/ui/field';
import { NativeSelectRoot, NativeSelectField } from '@/components/ui/native-select';
import { Input } from '@chakra-ui/react';
import { Path, useFormContext } from 'react-hook-form';
import { CreateAddressDto } from '../lib/api';
import States from './states';

interface AddressProps {
    isRequired: boolean;
    isReadOnly?: boolean;
    validAddress?: boolean;
    validCity?: boolean;
    validState?: boolean;
    validZipCode?: boolean;
    errorAddress?: string | undefined;
    errorCity?: string | undefined;
    errorState?: string | undefined;
    errorZipCode?: string | undefined;
    nameAddress: string;
    nameCity: string;
    nameState: string;
    nameZipCode: string;
}

export default function Address({
    isRequired,
    isReadOnly,
    validAddress,
    validCity,
    validState,
    validZipCode,
    errorAddress,
    errorCity,
    errorState,
    errorZipCode,
    nameAddress,
    nameCity,
    nameState,
    nameZipCode,
}: AddressProps) {
    const { register } = useFormContext<CreateAddressDto>();

    return (
        <>
            <Field label="Address" required={isRequired} readOnly={isReadOnly} invalid={validAddress} errorText={errorAddress}>
                <Input type="text" id={nameAddress} {...register(nameAddress as Path<CreateAddressDto>)} />
            </Field>
            <FieldRow>
                <Field label="City" required={isRequired} readOnly={isReadOnly} invalid={validCity} errorText={errorCity}>
                    <Input type="text" id={nameCity} {...register(nameCity as Path<CreateAddressDto>)} />
                </Field>
                <Field label="State" required={isRequired} disabled={isReadOnly} invalid={validState} errorText={errorState}>
                    <NativeSelectRoot variant="outline" id={nameState}>
                        <NativeSelectField {...register(nameState as Path<CreateAddressDto>)}>
                            <States />
                        </NativeSelectField>
                    </NativeSelectRoot>
                </Field>
                <Field label="ZIP" required={isRequired} readOnly={isReadOnly} invalid={validZipCode} errorText={errorZipCode}>
                    <Input type="text" id={nameCity} {...register(nameZipCode as Path<CreateAddressDto>)} maxLength={10} />
                </Field>
            </FieldRow>
        </>
    );
}
